import { EStarredChatsListActionTypes, IStarredChatsListRequest } from './types';
import { TChatDataInListSchema } from '../../types/chatList';
import { actionGenerator } from '../../utils/redux/actionGenerator';

/**
 * Запрос за списком архивных чатов
 */
export const setStarredChatsListPending = actionGenerator<
  EStarredChatsListActionTypes.SetPending,
  IStarredChatsListRequest
>(EStarredChatsListActionTypes.SetPending);

/**
 * Установить список архивных чатов
 */
export const setStarredChatsListSucceed = actionGenerator<
  EStarredChatsListActionTypes.SetSucceed,
  TChatDataInListSchema[]
>(EStarredChatsListActionTypes.SetSucceed);

/**
 * Установить ошибку запроса списка архивных чатов
 */
export const setStarredChatsListFailed = actionGenerator<EStarredChatsListActionTypes.SetFailed, void>(
  EStarredChatsListActionTypes.SetFailed,
);
